export { default } from "./CarDetailsBox"